import React from "react";
import InputSingle from "../../elements/input/InputSingle";
import SMSelect from "../../elements/select/SMSelect";
import styled from "styled-components";
import { ChevronLeftIcon } from "@heroicons/react/solid";
import ButtonPrimary from "../../elements/button/ButtonPrimary";
const DivNumber = styled.div`
  display: grid;
  grid-template-columns: repeat(8, auto);
  grid-gap: 4px;
`;

const DetailKuesioner = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const type = urlParams.get("type");
  console.log(type);

  function _renderTypeOne(params) {
    return (
      <div
        className="w-full flex flex-row px-10 py-10 dark:text-white"
        style={{ minHeight: "100vh" }}
      >
        <div className="w-5/12 flex flex-col pr-10">
          <p>Detail kuesioner</p>
          <h1 className="text-3xl font-bold">Kuesioner Sarpras</h1>

          <p className="mt-4">
            Kuesioner untuk mengetahui sarana prasarana sekolah
          </p>

          <div className="grid grid-flow-col auto-cols-max gap-4 my-6">
            <button className="px-6 py-2 bg-blue-200 rounded-lg border border-blue-600">
              <h1 className="text-blue-600">K-1288909</h1>
            </button>
            <button className="px-6 py-2 bg-blue-200 rounded-lg border border-blue-600">
              <h1 className="text-blue-600">K-1288909</h1>
            </button>
            <button className="px-6 py-2 bg-blue-200 rounded-lg border border-blue-600">
              <h1 className="text-blue-600">K-1288909</h1>
            </button>
          </div>

          <div className="grid grid-flow-row grid-cols-2 grid-rows-2 gap-4 mb-6">
            <div className="flex flex-col">
              <p>NPSN</p>
              <InputSingle />
            </div>
            <div className="flex flex-col">
              <p>Institusi / Sekolah</p>
              <InputSingle />
            </div>
            <div className="flex flex-col">
              <p>Jenis User</p>
              <SMSelect />
            </div>
            <div className="flex flex-col">
              <p>Username</p>
              <InputSingle />
            </div>
          </div>

          <div className="flex-col">
            <p>Nama Responden</p>
            <h1 className="font-bold text-2xl text-blue-500">
              Bambang Saputra
            </h1>
          </div>

          <div className="my-6">
            <DivNumber>
              {[...Array(40).keys()].map((x) => {
                return (
                  <div key={x}>
                    <button className="px-4 py-2 bg-blue-200 rounded-lg border border-blue-600">
                      <h1 className="text-blue-600">{x + 1}</h1>
                    </button>
                  </div>
                );
              })}
            </DivNumber>
          </div>

          <div className="flex flex-row my-4">
            <button
              className="flex flex-row gap-4"
              onClick={() => window.history.back()}
            >
              <ChevronLeftIcon className="w-6 h-6" />
              Kembali
            </button>
          </div>
        </div>

        <div
          className="w-7/12 bg-gray-200 rounded-lg"
          style={{
            maxHeight: "95vh",
            overflowY: "scroll",
          }}
        >
          <p className="text-blue-600 p-6">Pengisian jawaban kuesioner</p>
          {[...Array(10).keys()].map((x) => (
            <div key={x} className="flex flex-col p-6">
              <div className="flex flex-row">
                <div className="dark:text-gray-800">
                  <h1>1</h1>
                </div>
                <div className="flex-1 flex flex-col px-4 dark:text-gray-800">
                  <div>
                    <p>
                      Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                      Iste nobis sed praesentium rerum ab nisi molestiae vitae
                      placeat laudantium eius soluta unde velit, iure corporis
                      ratione repudiandae laborum facilis est.
                    </p>
                  </div>

                  <div className="flex flex-col">
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        className="form-radio"
                        name="radio"
                        value="1"
                      />
                      <span className="ml-2">Option 1</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        className="form-radio"
                        name="radio"
                        value="1"
                      />
                      <span className="ml-2">Option 1</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        className="form-radio"
                        name="radio"
                        value="1"
                      />
                      <span className="ml-2">Option 1</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        className="form-radio"
                        name="radio"
                        value="1"
                      />
                      <span className="ml-2">Option 1</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  function _renderTypeTwo(params) {
    return (
      <div
        className="w-full flex flex-row px-10 py-10 dark:text-white"
        style={{ minHeight: "100vh" }}
      >
        <div className="w-5/12 flex flex-col pr-10">
          <p>Detail kuesioner</p>
          <h1 className="text-3xl font-bold">Kuesioner Sarpras</h1>

          <p className="mt-4">
            Kuesioner untuk mengetahui sarana prasarana sekolah
          </p>

          <div className="grid grid-flow-col auto-cols-max gap-4 my-6">
            <button className="px-6 py-2 bg-blue-200 rounded-lg border border-blue-600">
              <h1 className="text-blue-600">K-1288909</h1>
            </button>
            <button className="px-6 py-2 bg-blue-200 rounded-lg border border-blue-600">
              <h1 className="text-blue-600">K-1288909</h1>
            </button>
            <button className="px-6 py-2 bg-blue-200 rounded-lg border border-blue-600">
              <h1 className="text-blue-600">K-1288909</h1>
            </button>
          </div>

          <div className="grid grid-flow-row grid-cols-2 grid-rows-2 gap-4 mb-6">
            <div className="flex flex-col">
              <p>NPSN</p>
              <InputSingle />
            </div>
            <div className="flex flex-col">
              <p>Institusi / Sekolah</p>
              <InputSingle />
            </div>
            <div className="flex flex-col">
              <p>Jenis User</p>
              <SMSelect />
            </div>
            <div className="flex flex-col">
              <p>Username</p>
              <InputSingle />
            </div>
          </div>

          <div className="flex-col">
            <p>Nama Responden</p>
            <h1 className="font-bold text-2xl text-blue-500">
              Bambang Saputra
            </h1>
          </div>

          <div className="my-6">
            <DivNumber>
              {[...Array(40).keys()].map((x) => {
                return (
                  <div key={x}>
                    <button className="px-4 py-2 bg-blue-200 rounded-lg border border-blue-600">
                      <h1 className="text-blue-600">{x + 1}</h1>
                    </button>
                  </div>
                );
              })}
            </DivNumber>
          </div>

          <div className="flex flex-row my-4">
            <button
              className="flex flex-row gap-4"
              onClick={() => window.history.back()}
            >
              <ChevronLeftIcon className="w-6 h-6" />
              Kembali
            </button>
          </div>
        </div>

        <div className="w-7/12 bg-gray-200 rounded-lg flex flex-col items-center justify-center">
          <div className="flex">
            <ButtonPrimary text="Download file kuesioner" type="solid" />
          </div>
        </div>
      </div>
    );
  }

  if (type === 1 || type === "1") {
    return _renderTypeOne();
  } else if (type === 2 || type === "2") {
    return _renderTypeTwo();
  }
  return <></>;
};

export default DetailKuesioner;
